import { useQuery } from "@tanstack/react-query";

import { getIncentivesPotentialPayoutsAdmin, getIncentivesPotentialPayoutsByFarmId } from "services";

import { GET_INCENTIVES_POTENTIAL_PAYOUTS, GET_INCENTIVES_POTENTIAL_PAYOUTS_ADMIN } from "consts";

import { IncentivesPotentialPayouts } from "models";

export const useGetIncentivesPotentialPayoutsByFarmId = (farmId: string | undefined) => {
  const { data } = useQuery<IncentivesPotentialPayouts>({
    queryKey: [GET_INCENTIVES_POTENTIAL_PAYOUTS, farmId],
    queryFn: () => getIncentivesPotentialPayoutsByFarmId(farmId ?? ""),
    enabled: !!farmId,
  });
  return { incentivesPotentialPayouts: data };
};

export const useGetIncentivesPotentialPayoutsAdmin = (farmId: string | undefined) => {
  const { data } = useQuery<IncentivesPotentialPayouts>({
    queryKey: [GET_INCENTIVES_POTENTIAL_PAYOUTS_ADMIN, farmId],
    queryFn: () => getIncentivesPotentialPayoutsAdmin({ farmId: farmId ?? "" }),
    enabled: !!farmId,
  });
  return { incentivesPotentialPayouts: data };
};
